import React from 'react'
import Select from "react-select";
import makeAnimated from 'react-select/animated';


const animatedComponents = makeAnimated();



export const SelectElement = ({ options, name, isMulti, closeOnMenuSelect, onChange, className, seleccionado, isClearable, onfocus }) => {

    // const [optionSelected, setSelectedOptions] = useState('');
    let e = ''


    if(isClearable == undefined) isClearable= true;
     
    if(options !== "" ){
        e = (options.map( item => item.value ).indexOf(seleccionado) )
    }
    
    return (
        <Select
            options={ options }
            isLoading={ !options }
            components={ animatedComponents }
            isSearchable= {true}
            isClearable= { isClearable }
            getOptionValue={(option) => `${option['label']}`}
            closeMenuOnSelect={closeOnMenuSelect}
            defaultValue= { options[e] }
            id={name}
            name={name}
            isMulti= {isMulti}
            onMenuClose={true}
            placeholder= "Seleccione"
            noOptionsMessage= {() => "No hay resultados"}
            onChange = {onChange}
            onFocus={ onfocus }
            classNames={{

                control: (state) =>
                    state.isFocused ? `${className}` : `${className}`
            }}
            menuPortalTarget={document.body}
            menuPosition="fixed" // posición fija respecto al viewport
            styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            
        />
    )
}
